import React, { useState } from 'react';

export default function ImportModal({ onImport, closeModal }) {
  const [data, setData] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!data.trim()) { setError('Nothing to import.'); return; }
    setSubmitting(true);
    try {
      await onImport(data);
      closeModal();
    } catch (err) {
      setError(err.response?.data?.message || 'Import failed.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      {error && <div className="text-steam-danger text-xs mb-3">{error}</div>}
      <label className="block text-[10px] font-bold uppercase tracking-[0.05em] text-surface-muted mb-1">CSV / newline-delimited</label>
      <textarea
        value={data}
        onChange={(e) => setData(e.target.value)}
        placeholder="76561198…,username,password"
        rows={8}
        className="w-full px-[10px] py-2 bg-surface-base text-surface-text border border-surface-border text-xs font-mono focus:outline-none focus:ring-2 focus:ring-accent rounded-[2px] resize-y"
      />
      <div className="text-[10px] text-surface-muted my-3 leading-snug">
        One per line. Columns: <code className="text-accent">steamId64</code>, <code className="text-accent">username</code>, <code className="text-accent">password</code>. Credentials optional. Duplicates skipped.
      </div>
      <div className="flex gap-2 justify-end">
        <button type="button" onClick={closeModal} className="px-[14px] py-2 bg-transparent text-surface-muted border border-surface-border text-[11px] font-semibold uppercase tracking-wider rounded-[2px]">Cancel</button>
        <button type="submit" disabled={submitting} className="px-[14px] py-2 bg-accent text-surface-base border-0 text-[11px] font-bold uppercase tracking-wider rounded-[2px] disabled:opacity-60">{submitting ? 'Importing…' : 'Import'}</button>
      </div>
    </form>
  );
}
